import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../Header";

import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";
import { useSidebar } from "../../App";

export default function HelpScan() {
  const { t } = useTranslation("help");
  const { sidebarCollapsed } = useSidebar();

  return (
    <div className="theme-whbl">

      {/* Internal CSS */}
      <style>
        {`
          .help-row {
            display: flex;
            gap: 16px;
            padding: 16px 18px;
            border-bottom: 1px solid #e5e7eb;
            align-items: flex-start;
          }

          .help-row:last-child {
            border-bottom: none;
          }

          /* 50% TEXT */
          .help-row p {
            width: 50%;
            max-width: 50%;
            margin: 0;
            font-size: 14px;
            line-height: 1.6;
            color: #ffffff;
          }

          /* 50% IMAGE */
          .help-row img {
            width: 50%;
            max-width: 50%;
            border-radius: 6px;
          }

          /* Mobile */
          @media (max-width: 768px) {
            .help-row {
              flex-direction: column;
            }

            .help-row p,
            .help-row img {
              width: 100%;
              max-width: 100%;
            }
          }
        `}
      </style>

      <div className="container-fluid">
        <div className="main-container">

          <main
            className={`${sidebarCollapsed ? "col-11" : "col-10"}`}
            style={{
              width: "100%",
              overflowX: "auto"
            }}
          >
            <div className="dashboard">

              {/* Title */}
              <div className="pm-header">
                <h1 className="pm-title">
                  {t("helpScan.title")}
                </h1>
              </div>

              {/* Scan Steps */}
              <div className="help-content">

                <div className="help-row">
                  <p>
                    {t("helpScan.steps.step1")}
                  </p>

                  <img
                     src={t("helpScan.imageLogin")}
                    alt={t("helpScan.images.step1Alt")}
                  />
                </div>

                <div className="help-row">
                  <p>
                    {t("helpScan.steps.step2")}
                  </p>

                  <img
                     src={t("helpScan.image")}
                    alt={t("helpScan.images.step2Alt")}
                  />
                </div>

                <div className="help-row">
                  <p>
                    {t("helpScan.steps.step3")}
                  </p>
 <img
                     src={t("helpScan.imageSc")}
                    alt={t("helpScan.images.step5Alt")}
                  />
                 
                </div>

              

                <div className="help-row">
                  <p>
                    {t("helpScan.steps.step5")}
                  </p>

                  <img
                     src={t("helpScan.image3")}
                    alt={t("helpScan.images.step5Alt")}
                  />
                </div>

                <div className="help-row">
                  <p>
                    {t("helpScan.steps.step6")}
                  </p>

                  <img
                     src={t("helpScan.image4")}
                    alt={t("helpScan.images.step6Alt")}
                  />
                </div>

                <div className="help-row">
                  <p>
                    {t("helpScan.steps.step7")}
                  </p>

                  <img
                    src={t("helpScan.image5")}
                    alt={t("helpScan.images.step7Alt")}
                  />
                </div>

              </div>

            </div>
          </main>

        </div>
      </div>
    </div>
  );
}